var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column ma-0 pa-0",style:(`min-height:${_vm.minHeight}px`)},[_c('span',{staticClass:"paragraph font-weight-bold blue-grey--text text--darken-3"},[_vm._v(_vm._s(_vm.title))]),(_vm.paragraph)?_c('span',{staticClass:"paragraph blue-grey--text text--darken-3 my-2"},[_vm._v(_vm._s(_vm.paragraph))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }